// src/utils/delegateEligiblesLink.js

/**
 * PURPOSE: Reglas puras del enlace "Gestionar elegibles" en las cards Rugby de Programación (FTR-0015).
 * RESPONSIBILITIES: Mostrar el enlace solo con el interruptor encendido, en Rugby (familia 6 de formatIdSport), con
 *   ambos equipos definidos y en estados no terminales (distintos de −2, 3 y 4); construir la URL
 *   {origen}/es/delegados/partidos/{id-slug}/elegibles. Solo navegación, nunca autorización.
 * COLLABORATORS: src/config/delegatePortal.js, src/utils/formatIdSport.js, Programacion.jsx.
 */
import { formatIdSport } from "./formatIdSport.js";

const RUGBY_FORMAT = 6;
const TERMINAL_STATES = new Set([-2, 3, 4]);

const slugify = (value) =>
  String(value || "")
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const shouldShowEligiblesLink = ({ enabled, idsport, match }) =>
  Boolean(
    enabled &&
      formatIdSport(Number(idsport)) === RUGBY_FORMAT &&
      Number(match?.idmatch) > 0 &&
      match?.Participant1 &&
      match?.Participant2 &&
      !TERMINAL_STATES.has(Number(match?.state))
  );

export const buildEligiblesUrl = ({ origin, match }) => {
  const home = match?.Participant1?.Institution?.abrev || match?.Participant1?.Institution?.name || "";
  const away = match?.Participant2?.Institution?.abrev || match?.Participant2?.Institution?.name || "";
  const slug = slugify([home, away].filter(Boolean).join(" vs "));
  const param = slug ? `${Number(match.idmatch)}-${slug}` : String(Number(match.idmatch));
  return `${String(origin || "").replace(/\/+$/, "")}/es/delegados/partidos/${param}/elegibles`;
};
